import PUBLICO from '@/constants/ma/dadosEstado/portal/publico'
import GERAL from '@/constants/ma/dadosEstado/geral'
import ANALISE from '@/constants/ma/dadosEstado/analise'
import FINANCEIRO from '@/constants/ma/dadosEstado/financeiro'

export default {
  ...GERAL,
  PUBLICO,
  ANALISE,
  FINANCEIRO
}



// WEBPACK FOOTER //
// ./src/constants/ma/dadosEstado/index.js